import { render, staticRenderFns } from "./SiteContentEditor.vue?vue&type=template&id=5bbb6516&scoped=true"
import script from "./SiteContentEditor.vue?vue&type=script&lang=js"
export * from "./SiteContentEditor.vue?vue&type=script&lang=js"
import style0 from "./SiteContentEditor.vue?vue&type=style&index=0&id=5bbb6516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb6516",
  null
  
)

export default component.exports